import React, { useState } from 'react';
import mockUser from '../../mock/mockUser';
import { mockOpenAISummary } from '../../mock/mockAI';

const FactFinderSummary = () => {
  const [summary, setSummary] = useState('');
  const { profile, accounts, liabilities, monthly_spending, protection, factFinder } = mockUser;
  const totalAssets = accounts.reduce((sum, acc) => sum + acc.balance, 0);
  const totalLiabilities = liabilities.reduce((sum, liab) => sum + liab.balance, 0);
  const netWorth = totalAssets - totalLiabilities;
  const totalSpending = Object.values(monthly_spending).reduce((sum, v) => sum + v, 0);
  const goals = factFinder?.goals || [];
  const insuranceStatus = protection && protection.length > 0 ? 'Active' : 'None';
  const estate = factFinder?.estate || {};

  return (
    <div className="max-w-3xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-6">Fact Finder Summary</h1>
      <div className="bg-white rounded-2xl shadow-sm p-6 mb-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">
          <div>
            <div className="text-gray-700 font-medium mb-1">Name</div>
            <div className="text-lg font-bold text-gray-900 mb-2">{profile.name}</div>
            <div className="text-gray-700 mb-1">Age: <span className="font-semibold">{profile.age}</span></div>
            <div className="text-gray-700 mb-1">Job: <span className="font-semibold">{profile.occupation}</span></div>
            <div className="text-gray-700 mb-1">Location: <span className="font-semibold">{profile.location}</span></div>
            <div className="text-gray-700">Income: <span className="font-semibold">${profile.income.toLocaleString()}</span></div>
          </div>
          <div>
            <div className="text-gray-700 font-medium mb-1">Net Worth</div>
            <div className="text-2xl font-bold text-blue-700 mb-2">${netWorth.toLocaleString()}</div>
            <div className="text-gray-700 mb-1">Assets: <span className="font-semibold text-green-700">${totalAssets.toLocaleString()}</span></div>
            <div className="text-gray-700">Liabilities: <span className="font-semibold text-red-700">${totalLiabilities.toLocaleString()}</span></div>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">
          <div>
            <div className="text-gray-700 font-medium mb-1">Monthly Spending</div>
            <div className="text-2xl font-bold text-red-700 mb-2">${totalSpending.toLocaleString()}</div>
            <ul className="text-sm text-gray-600 space-y-1">
              {Object.entries(monthly_spending).map(([cat, amt]) => (
                <li key={cat}>{cat.replace('_', ' ')}: <span className="font-semibold">${amt.toLocaleString()}</span></li>
              ))}
            </ul>
          </div>
          <div>
            <div className="text-gray-700 font-medium mb-1">Goals</div>
            <ul className="list-disc pl-5 text-sm text-gray-700 space-y-1">
              {goals.map((g, i) => <li key={i}>{g}</li>)}
            </ul>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">
          <div>
            <div className="text-gray-700 font-medium mb-1">Insurance Status</div>
            <div className="text-gray-900 font-semibold mb-1">{insuranceStatus}</div>
            {protection && protection.length > 0 && (
              <ul className="text-sm text-gray-600 space-y-1">
                {protection.map((p, i) => (
                  <li key={i}>{p.type.replace('_', ' ')}: ${p.coverage.toLocaleString()} ({p.status})</li>
                ))}
              </ul>
            )}
          </div>
          <div>
            <div className="text-gray-700 font-medium mb-1">Estate Planning</div>
            <div className="text-gray-900 font-semibold mb-1">Will: {estate.will ? 'Yes' : 'No'}, Trust: {estate.trust ? 'Yes' : 'No'}</div>
            <div className="text-sm text-gray-600">Health Care Proxy: {estate.healthCareProxy ? 'Yes' : 'No'}</div>
            <div className="text-xs text-gray-400 mt-1">{estate.notes}</div>
          </div>
        </div>
        <div className="mt-6">
          <div className="flex items-center gap-4 mb-2">
            <button
              className="bg-blue-500 text-white px-4 py-2 rounded-lg font-semibold hover:bg-blue-600"
              onClick={() => setSummary(mockOpenAISummary())}
            >
              Generate Summary
            </button>
            <button className="bg-gray-100 text-gray-700 px-4 py-2 rounded-lg font-semibold cursor-not-allowed" disabled>
              Download PDF
            </button>
          </div>
          <div className="bg-blue-50 rounded-xl p-4 mt-2 min-h-[60px]">
            <span className="text-gray-700 text-sm">{summary || 'Click "Generate Summary" to see the advisor summary.'}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FactFinderSummary; 